export default __webpack_public_path__ + "static/media/Ghee, Oil & Masala.5331c454.png";